
export default {
  props: {
    selectClass: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    labelFor: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
  },
}
